<script>
import $dayjs from '@/services/date'
import { debounce } from 'lodash'
import baseMixin from '@/mixins/baseMixin'
import DateFormatToken from '@/shared/constants/date/DateFormatToken'
import DateStripDay from './date-strip-day.vue'

export default {
  name: 'DateStrip',
  components: { DateStripDay },
  mixins: [baseMixin],
  props: {
    selectedDay: {
      type: String,
      default: function () {
        return $dayjs().format('DateFormatToken.YYYYMMDD')
      },
    },
    year: {
      type: Number,
      required: true,
    },
    bookings: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      menu: null,
      displayDate: new Date(),
      selectedDate: new Date(),
      dateFormat: DateFormatToken.DDMMYYYYWithSlash,
      dayFormat: DateFormatToken.D,
      dayNameFormat: DateFormatToken.ddd,
      monthFormat: DateFormatToken.MMM,
    }
  },
  computed: {
    activeDayString() {
      return $dayjs(this.selectedDate).format(DateFormatToken.YYYYMMDD)
    },
    displaySliderDay() {
      return $dayjs(this.displayDate).date() - 1
    },
    displaySliderMonth() {
      return $dayjs(this.displayDate).month()
    },
    selectedSliderDay() {
      return $dayjs(this.selectedDate).date() - 1
    },
    selectedSliderMonth() {
      return $dayjs(this.selectedDate).month()
    },
    returnMonthsArray() {
      const ar = []
      for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
        const tmpDate = new Date(2000, monthIndex, 1)

        ar.push({
          monthIndex,
          displayString: $dayjs(tmpDate).format(this.monthFormat),
        })
      }
      return ar
    },
    returnDaysArray() {
      const daysArray = []

      const firstDayOfSelectedMonth = new Date(
        this.year,
        this.displaySliderMonth,
        1
      )

      const thisMonthDayJS = $dayjs(firstDayOfSelectedMonth)

      for (
        let monthIndex = 1;
        monthIndex < thisMonthDayJS.daysInMonth() + 1;
        monthIndex++
      ) {
        const tmpDate = new Date(this.year, this.displaySliderMonth, monthIndex)
        const tmpDayJs = $dayjs(tmpDate)

        daysArray.push({
          monthIndex,
          displayString: tmpDayJs.format(this.dayFormat),
          displayStringDayName: tmpDayJs.format(this.dayNameFormat),
          dateObject: tmpDate,
        })
      }
      return daysArray
    },
    returnAvailableYears() {
      const years = []

      for (const booking of this.bookings) {
        years.push($dayjs(booking.dateLocal).format(DateFormatToken.YYYY))
      }
      return years
    },
  },
  watch: {
    selectedDay() {
      if (this.selectedDay) this.selectedDate = this.selectedDay
    },
  },
  created() {
    this.selectedDate = this.selectedDay
  },
  methods: {
    handleDayClick: debounce(async function (day) {
      // get the number of items for skeleton loader
      let numberOfBookings = 0

      const dayStr = $dayjs(day.dateObject).format(
        `${DateFormatToken.YYYYMMDD}T00:00:00`
      )

      const item = this.bookings.filter((x) => x.dateLocal === dayStr)

      if (item.length === 1) numberOfBookings = item[0].totalBookingsCount

      this.selectedDate = day.dateObject

      this.$emit('dateSelected', day.dateObject, numberOfBookings)
    }, 200),
    numberOfBookings(day) {
      if (this.bookings.length === 0) return 0

      const dayStr = $dayjs(day.dateObject).format(
        `${DateFormatToken.YYYYMMDD}T00:00:00`
      )
      const item = this.bookings.filter((x) => x.dateLocal === dayStr)

      return item.length > 0 ? item[0].totalBookingsCount : 0
    },
    monthChanged(monthIndex) {
      this.displayDate = new Date(this.year, monthIndex, 1)
      this.$emit('monthChanged', monthIndex)
    },
    isCurrentMonth(index) {
      const today = $dayjs()
      return today.$M === index && today.$y === this.year
    },
    isSelected(dayObject) {
      return (
        $dayjs(dayObject).format(DateFormatToken.YYYYMMDD) ===
        this.activeDayString
      )
    },
  },
}
</script>

<template>
  <div class="dateStrip">
    <div class="yearMonth">
      <div class="month">
        <v-slide-group
          :value="selectedSliderMonth"
          center-active
          :class="[isMobileViewPort ? 'mx-0 mx-n2' : '', 'py-4']"
          show-arrows
          mandatory
          @change="monthChanged"
        >
          <v-slide-item
            v-for="(x, index) in returnMonthsArray"
            :key="'bookingstrip_months_' + index"
            v-slot="{ active, toggle }"
            style="flex-basis: 0; flex-grow: 1"
          >
            <v-btn
              :class="[
                'mb-2',
                isCurrentMonth(index) ? 'border border--blue' : '',
                active ? 'border--white custom-elevation' : '',
              ]"
              :text="!active"
              color="blue"
              dark
              @click="toggle"
              >{{ x.displayString }}</v-btn
            >
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>
    <div class="days">
      <v-slide-group
        :value="selectedSliderDay"
        center-active
        :class="[isMobileViewPort ? 'mr-0 mx-n2' : 'mx-n3', 'py-4']"
        show-arrows
        mandatory
      >
        <v-slide-item
          v-for="(day, index) in returnDaysArray"
          :key="'bookingstrip_' + year + '_' + index"
          class="date-strip--group-item"
        >
          <DateStripDay
            :selected="isSelected(day.dateObject)"
            :day="day"
            :counter="numberOfBookings(day)"
            @handle-click="handleDayClick"
          />
        </v-slide-item>
      </v-slide-group>
    </div>
  </div>
</template>

<style lang="scss">
.date-strip--group-item {
  flex-basis: 0;
  flex-grow: 1;
  min-width: 45px;
}
</style>
